<template>
    <div class="locator__searchTab">
        <form class="locator__searchInput" v-on:submit.prevent="onSubmit">
            <input type="search" class="locator__input" v-model="search"/>
            <button type="submit" class="locator__button button view-primary-light">Vyhledat</button>
        </form>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {mapFields} from 'vuex-map-fields';

    export default {
        name: 'LocatorSearchContainer',
        computed: {
            ...mapFields('locator', ['filter.search']),
            ...mapGetters('locator', ['locatorType']),
        },
        mounted() {
            this.setSearch(this.getSearchString());
        },
        watch: {
            '$route': function () {
                this.fetchContacts();
            },
        },
        methods: {
            ...mapActions('locator', ['setSearch', 'fetchContacts']),
            getSearchString() {
                return this.$route.query.q;
            },
            onSubmit() {
                let typeSearch;

                switch (this.locatorType) {
                    case 'companies':
                        typeSearch = 'locator.firmsAndCraftsmen';
                        break;
                    case 'contacts':
                        typeSearch = 'locator.contacts';
                        break;
                    case 'calculation':
                        typeSearch = 'calculation.contactSelect';
                        break;
                    default:
                        typeSearch = 'locator.salesPlaces';
                }
                if (this.search) {
                    this.$router.push({name: typeSearch + '.search', query: {q: this.search}})
                } else {
                    this.$router.push({name: typeSearch})
                }
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/locator/SearchContainer.vue